import { render } from "./GenrationTree.vue?vue&type=template&id=153d58fe&scoped=true"
import script from "./GenrationTree.vue?vue&type=script&lang=js"
export * from "./GenrationTree.vue?vue&type=script&lang=js"

import "./GenrationTree.vue?vue&type=style&index=0&id=153d58fe&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153d58fe"]])

export default __exports__